export const versionEndpoint = "api/version";
